export const navbarMenu = [
    {title: 'Home', url: '/'},
    {title: 'Movies', url: '/movie'},
    {title: 'TV', url: '/tv'},
    {title: 'Actors', url: '/persons'},
    {title: 'Contact us', url: '/contact'},
]